
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {EWhatsappConversationStatus, IWhatsappConversation} from '@/model/Helpdesk/IWhatsapp';
import HelpdeskAssigneePicker from '@/components/helpdesk/HelpdeskAssigneePicker.vue';

// Right-hand panel of a chat (Jira issue sidebar): status, assignee, ticket and contact.
// It only emits changes; the view saves them.
@Component({name: 'WhatsappConversationDetails', components: {HelpdeskAssigneePicker}})
export default class WhatsappConversationDetails extends Vue {
  @Prop({required: true}) conversation!: IWhatsappConversation;
  @Prop({type: Boolean, default: false}) saving!: boolean;

  statuses = Object.values(EWhatsappConversationStatus);

  statusLabel(status: string): string {
    return this.$t('helpdesk.whatsapp.status.' + status) as string;
  }

  formatDate(date: string | null): string {
    if (!date) return '—';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', {day: 'numeric', month: 'short', year: 'numeric'}) + ' '
      + d.toLocaleTimeString('es-ES', {hour: '2-digit', minute: '2-digit'});
  }

  copyPhone() {
    navigator.clipboard.writeText(this.conversation.phone)
      .then(() => this.$uiBus.emit('success', this.$t('helpdesk.whatsapp.details.phoneCopied')))
      .catch(() => undefined);
  }
}
